<div class="grid">
  <ng-container *ngFor="let row of rows">
    <ng-container *ngIf="(row.value$ | async) as value">
      <div class="label">{{row.label | translate}}:</div>
      <div class="value">{{value}}</div>
      <div class="unit">{{row.unit}}</div>
    </ng-container>
  </ng-container>
</div>
